import React from 'react';
import { FiX } from "react-icons/fi";

const StudentsList = ({
  studentList,
  handleStudentSelection,
  handleSendAttendance,
  closeStudentList,
  arr,
  setArr,
  activeDayIndex,
  activeMonthIndex,
  activeYearIndex,
  months,
  years,
}) => {
  const selectedDate = `${activeDayIndex + 1}/${months[activeMonthIndex]}/${years[activeYearIndex]}`;

  const handleToggleStudent = (studentId) => {
    if (arr.includes(studentId)) {
      // If studentId is already in arr, remove it
      setArr(arr.filter((id) => id !== studentId));
    } else {
      // If studentId is not in arr, add it
      setArr([...arr, studentId]);
    }
  };

  // Check if a student was absent on the selected date
  const isAbsentOnSelectedDate = (student) => {
    if (
      student.date_of_absence &&
      typeof student.date_of_absence === "string"
    ) {
      let absentsDate = student.date_of_absence.split(" ");
      return absentsDate.includes(selectedDate);
    }
    return false;
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto p-4 pt-24">
      <div className="bg-white rounded-lg shadow-lg p-4 mt-5 w-full max-w-md">
        <div className="flex justify-end mb-4">
          <button
            onClick={closeStudentList}
            className="text-gray-500 hover:text-gray-800 focus:outline-none"
          >
            <FiX className="h-6 w-6" />
          </button>
        </div>
        <h2 className="text-2xl font-bold mb-2">Student List</h2>
        <ul className="divide-y divide-gray-200">
          {studentList.map((student) => (
            <li
              key={student.id}
              onClick={() => handleToggleStudent(student.id)}
              className="pt-2 mb-2 cursor-pointer"
              style={{
                color: arr.includes(student.id) || isAbsentOnSelectedDate(student)
                  ? "red"
                  : "black",
              }}
            >
              <p>Name: {student.name}</p>
            </li>
          ))}
        </ul>
        <div className="flex justify-center mt-5">
          <button
            type="button"
            className="bg-gray-300 hover:bg-gray-400 text-bold px-9 py-2 rounded-full focus:outline-none cursor-pointer"
            onClick={handleSendAttendance}
          >
            Submit Attendance
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentsList;
